import { useNavigate } from "react-router-dom";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Button } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from "recharts";
import RecentActivities from "../../features/dashboard/recentActivities";

const dauData = [
  { name: "Mon", users: 120 },
  { name: "Tue", users: 210 },
  { name: "Wed", users: 180 },
  { name: "Thu", users: 300 },
  { name: "Fri", users: 260 },
  { name: "Sat", users: 140 },
  { name: "Sun", users: 170 },
];

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Dashboard</h1>
      </div>

      <div className="stats_boxes gap_m">
        <div className="cards" onClick={() => navigate("/manage-users")}>
          <figure>
            <img src="/static/images/user_icon.svg" alt="Users" />
          </figure>
          <h2>50</h2>
          <p>Active users</p>
        </div>

        <div className="cards" onClick={() => navigate("/manage-users")}>
          <figure>
            <img src="/static/images/user_icon.svg" alt="Active Users" />
          </figure>
          <h2>15</h2>
          <p>Workout completion rates</p>
        </div>

        <div className="cards" onClick={() => navigate("")}>
          <figure>
            <img src="/static/images/offer_icon.svg" alt="Revenue" />
          </figure>
          <h2>20</h2>
          <p>Subscription conversions</p>
        </div>
        <div className="cards" onClick={() => navigate("")}>
          <figure>
            <img src="/static/images/order.svg" alt="Revenue" />
          </figure>
          <h2>20</h2>
          <p>Program engagement </p>
        </div>
        <div className="cards" onClick={() => navigate("")}>
          <figure>
            <img src="/static/images/order.svg" alt="Revenue" />
          </figure>
          <h2>20000</h2>
          <p>Community activity</p>
        </div>
        <div className="cards" onClick={() => navigate("")}>
          <figure>
            <img src="/static/images/order.svg" alt="Revenue" />
          </figure>
          <h2>20000</h2>
          <p>Email opt-ins (via MailerLite)</p>
        </div>
      </div>
      <div className="grid_sc gap_m">
        {/* Daily Active Users Chart */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Activity</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
              <Button className="btn btn_black icon_btn"><FileDownloadIcon /> </Button>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={dauData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="users" fill="#C9C1B1"/>
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Total Revenue</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
              <Button className="btn btn_black icon_btn"><FileDownloadIcon /> </Button>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={dauData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="users" fill="#C9C1B1" />
            </BarChart>
          </ResponsiveContainer>
        </div>

      </div>

    </>
  );
};

export default Dashboard;